import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../store/rootReducer';
import { successGrowl } from '../../store/rootThunks';
import { SubtenantConstants } from '../definitions';

const EMPTY = { name: '', affiliation: '' };

export default function EditSubtenantModal({
  open,
  onClose,
  subtenant,
  saveSubtenant,
  isNew,
  showAffiliation,
}) {
  const [values, setValues] = useState(EMPTY);
  const dispatch = useDispatch();
  useEffect(() => {
    setValues(subtenant ? { ...subtenant } : EMPTY);
  }, [subtenant]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };
  const handleSave = async () => {
    try {
      await saveSubtenant(values, isNew);
      dispatch(
        successGrowl({
          groupId: SubtenantConstants.defaultPageId,
          props: 'Subtenant saved successfully.',
        })
      );
    } catch (err) {
      dispatch(
        showSnackbar({
          message: err.message || 'Server error, please try again.',
          severity: 'error',
        })
      );
    } finally {
      setValues(EMPTY);
      onClose();
    }
  };
  const isSaveDisabled = !values.name;
  return (
    <Modal show={open} animation={false}>
      <Modal.Header>
        <Modal.Title>{subtenant ? 'Edit Subtenant' : 'Add Subtenant'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextField
          fullWidth
          margin="normal"
          label="Name"
          name="name"
          value={values.name}
          onChange={handleChange}
        />
        {showAffiliation && (
          <TextField
            fullWidth
            margin="normal"
            label="Affiliation"
            name="affiliation"
            value={values.affiliation || ''}
            onChange={handleChange}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSave} disabled={isSaveDisabled}>
          Save
        </Button>
        <Button variant="cancel" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
